import React from 'react';
import './AccountHeader.scss';
import {
  IonProgressBar,
  IonFabButton,
  IonButton,
  IonRouterLink
} from '@ionic/react';
import { AuthenticationRootState } from '../store/reducers/authentication';
import { connect } from 'react-redux';
import { useLoginCallback } from '../hooks/msal.hooks';

const mapStateToProps = (
  state: { authentication: AuthenticationRootState },
  ownProps: any
) => {
  return {
    user: state.authentication.user,
    isLoggedIn: !!state.authentication.accessToken
  };
};

const AccountHeader: React.FC<ReturnType<typeof mapStateToProps>> = ({
  user,
  isLoggedIn
}) => {
  const handleLogin = useLoginCallback();
  return (
    <div className="home__header">
      {isLoggedIn ? (
        <>
          <IonRouterLink
            className="home__header__name"
            routerLink="/dashboard/mon-compte"
          >
            <h2>
              {user!.getFullName()}
              {/*<IonBadge color="secondary">11</IonBadge>*/}
            </h2>
            {/* <IonProgressBar value={0.5} /> */}
          </IonRouterLink>
          <div>
            <IonFabButton
              className="initials info"
              routerLink="/dashboard/mon-compte"
            >
              {user!.getInitials()}
            </IonFabButton>
          </div>
        </>
      ) : (
        <>
          <div className="home__header__name ion-hide-lg-up">
            <h2>Bienvenue,</h2>
            {isLoggedIn ? <IonProgressBar value={0} /> : null}
          </div>
          <div>
            <IonButton onClick={handleLogin} fill="clear">
              Connexion
            </IonButton>
          </div>
        </>
      )}
    </div>
  );
};

export default connect(mapStateToProps, null)(AccountHeader);
